// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as CustomerRouteImport } from './routes/_customer'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AppointmentsRouteImport } from './routes/appointments'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as MealPlansRouteImport } from './routes/meal-plans'
import { Route as OrderRouteImport } from './routes/order'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as RefundCancellationRouteImport } from './routes/refund-cancellation'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReturnPolicyRouteImport } from './routes/return-policy'
import { Route as ShippingDeliveryRouteImport } from './routes/shipping-delivery'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as TiffinRouteImport } from './routes/tiffin'
import { Route as WeeklyMenuRouteImport } from './routes/weekly-menu'
import { Route as AccountForgotPasswordRouteImport } from './routes/account.forgot-password'
import { Route as AccountSignInRouteImport } from './routes/account.sign-in'
import { Route as AccountSignUpRouteImport } from './routes/account.sign-up'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CareersIndexRouteImport } from './routes/careers.index'
import { Route as CareersSlugRouteImport } from './routes/careers.$slug'
import { Route as HealthProductsIndexRouteImport } from './routes/health-products.index'
import { Route as HealthProductsSlugRouteImport } from './routes/health-products.$slug'
import { Route as HealthProductsCartRouteImport } from './routes/health-products.cart'
import { Route as MealPlansSlugRouteImport } from './routes/meal-plans_.$slug'
import { Route as MealPlansConfigureRouteImport } from './routes/meal-plans_.configure'
import { Route as OrderIndexRouteImport } from './routes/order.index'
import { Route as OrderPayRouteImport } from './routes/order.pay'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin.admin.index'
import { Route as AdminAdminAboutRouteImport } from './routes/_admin.admin.about'
import { Route as AdminAdminAddonsRouteImport } from './routes/_admin.admin.addons'
import { Route as AdminAdminAvailabilityRouteImport } from './routes/_admin.admin.availability'
import { Route as AdminAdminBackupRestoreRouteImport } from './routes/_admin.admin.backup-restore'
import { Route as AdminAdminBeveragesRouteImport } from './routes/_admin.admin.beverages'
import { Route as AdminAdminBulkRouteImport } from './routes/_admin.admin.bulk'
import { Route as AdminAdminCareersRouteImport } from './routes/_admin.admin.careers'
import { Route as AdminAdminConsultationSettingsRouteImport } from './routes/_admin.admin.consultation-settings'
import { Route as AdminAdminContactRouteImport } from './routes/_admin.admin.contact'
import { Route as AdminAdminCouponsRouteImport } from './routes/_admin.admin.coupons'
import { Route as AdminAdminCustomerAnalyticsRouteImport } from './routes/_admin.admin.customer-analytics'
import { Route as AdminAdminCustomersRouteImport } from './routes/_admin.admin.customers'
import { Route as AdminAdminDeliveriesRouteImport } from './routes/_admin.admin.deliveries'
import { Route as AdminAdminDeliveryAreasRouteImport } from './routes/_admin.admin.delivery-areas'
import { Route as AdminAdminDeliveryPartnersRouteImport } from './routes/_admin.admin.delivery-partners'
import { Route as AdminAdminDeliveryRequestsRouteImport } from './routes/_admin.admin.delivery-requests'
import { Route as AdminAdminDeliveryTrackingRouteImport } from './routes/_admin.admin.delivery-tracking'
import { Route as AdminAdminDeliveryZonesRouteImport } from './routes/_admin.admin.delivery-zones'
import { Route as AdminAdminDemoDataRouteImport } from './routes/_admin.admin.demo-data'
import { Route as AdminAdminDispatchRouteImport } from './routes/_admin.admin.dispatch'
import { Route as AdminAdminDispatchBoardRouteImport } from './routes/_admin.admin.dispatch-board'
import { Route as AdminAdminEmailLogsRouteImport } from './routes/_admin.admin.email-logs'
import { Route as AdminAdminEnquiriesRouteImport } from './routes/_admin.admin.enquiries'
import { Route as AdminAdminFoodAnalyticsRouteImport } from './routes/_admin.admin.food-analytics'
import { Route as AdminAdminGoodsReceiptRouteImport } from './routes/_admin.admin.goods-receipt'
import { Route as AdminAdminHomepageRouteImport } from './routes/_admin.admin.homepage'
import { Route as AdminAdminImplementationWizardRouteImport } from './routes/_admin.admin.implementation-wizard'
import { Route as AdminAdminImportHistoryRouteImport } from './routes/_admin.admin.import-history'
import { Route as AdminAdminInventoryCategoriesRouteImport } from './routes/_admin.admin.inventory-categories'
import { Route as AdminAdminInventoryDashboardRouteImport } from './routes/_admin.admin.inventory-dashboard'
import { Route as AdminAdminInventoryReportsRouteImport } from './routes/_admin.admin.inventory-reports'
import { Route as AdminAdminInventorySuppliersRouteImport } from './routes/_admin.admin.inventory-suppliers'
import { Route as AdminAdminJournalRouteImport } from './routes/_admin.admin.journal'
import { Route as AdminAdminKitchenRouteImport } from './routes/_admin.admin.kitchen'
import { Route as AdminAdminKitchenProductionRouteImport } from './routes/_admin.admin.kitchen-production'
import { Route as AdminAdminLeadsRouteImport } from './routes/_admin.admin.leads'
import { Route as AdminAdminManualOrdersRouteImport } from './routes/_admin.admin.manual-orders'
import { Route as AdminAdminMealPlansRouteImport } from './routes/_admin.admin.meal-plans'
import { Route as AdminAdminMealPlansV2RouteImport } from './routes/_admin.admin.meal-plans-v2'
import { Route as AdminAdminMealPlansV2PreviewRouteImport } from './routes/_admin.admin.meal-plans-v2-preview'
import { Route as AdminAdminMediaRouteImport } from './routes/_admin.admin.media'
import { Route as AdminAdminNewsletterRouteImport } from './routes/_admin.admin.newsletter'
import { Route as AdminAdminOperationsRouteImport } from './routes/_admin.admin.operations'
import { Route as AdminAdminOrdersRouteImport } from './routes/_admin.admin.orders'
import { Route as AdminAdminProductOrdersRouteImport } from './routes/_admin.admin.product-orders'
import { Route as AdminAdminProductionCleanupRouteImport } from './routes/_admin.admin.production-cleanup'
import { Route as AdminAdminProductsRouteImport } from './routes/_admin.admin.products'
import { Route as AdminAdminPurchaseOrdersRouteImport } from './routes/_admin.admin.purchase-orders'
import { Route as AdminAdminReportsRouteImport } from './routes/_admin.admin.reports'
import { Route as AdminAdminReturnsRouteImport } from './routes/_admin.admin.returns'
import { Route as AdminAdminSaladsRouteImport } from './routes/_admin.admin.salads'
import { Route as AdminAdminSalesAnalyticsRouteImport } from './routes/_admin.admin.sales-analytics'
import { Route as AdminAdminSettingsRouteImport } from './routes/_admin.admin.settings'
import { Route as AdminAdminSettingsAiChatRouteImport } from './routes/_admin.admin.settings-ai-chat'
import { Route as AdminAdminShiftPlanningRouteImport } from './routes/_admin.admin.shift-planning'
import { Route as AdminAdminSoupsRouteImport } from './routes/_admin.admin.soups'
import { Route as AdminAdminStockAdjustmentsRouteImport } from './routes/_admin.admin.stock-adjustments'
import { Route as AdminAdminStockItemsRouteImport } from './routes/_admin.admin.stock-items'
import { Route as AdminAdminStockMovementRouteImport } from './routes/_admin.admin.stock-movement'
import { Route as AdminAdminSubscriptionExtensionsRouteImport } from './routes/_admin.admin.subscription-extensions'
import { Route as AdminAdminSystemConfigurationRouteImport } from './routes/_admin.admin.system-configuration'
import { Route as AdminAdminSystemHealthRouteImport } from './routes/_admin.admin.system-health'
import { Route as AdminAdminTenantsRouteImport } from './routes/_admin.admin.tenants'
import { Route as AdminAdminTestimonialsRouteImport } from './routes/_admin.admin.testimonials'
import { Route as AdminAdminTiffinRouteImport } from './routes/_admin.admin.tiffin'
import { Route as AdminAdminUsersRouteImport } from './routes/_admin.admin.users'
import { Route as AdminAdminVehiclesRouteImport } from './routes/_admin.admin.vehicles'
import { Route as AdminAdminVideoSpecialsRouteImport } from './routes/_admin.admin.video-specials'
import { Route as AdminAdminWalletRouteImport } from './routes/_admin.admin.wallet'
import { Route as AdminAdminWebsiteAnalyticsRouteImport } from './routes/_admin.admin.website-analytics'
import { Route as AdminAdminWeeklyMenuRouteImport } from './routes/_admin.admin.weekly-menu'
import { Route as AdminAdminWhatsappTemplatesRouteImport } from './routes/_admin.admin.whatsapp-templates'
import { Route as CustomerAccountIndexRouteImport } from './routes/_customer.account.index'
import { Route as CustomerAccountAddressesRouteImport } from './routes/_customer.account.addresses'
import { Route as CustomerAccountProfileRouteImport } from './routes/_customer.account.profile'
import { Route as CustomerAccountTiffinRouteImport } from './routes/_customer.account.tiffin'
import { Route as CustomerAccountWalletRouteImport } from './routes/_customer.account.wallet'
import { Route as ApiPublicVapiInitDebugRouteImport } from './routes/api/public/vapi-init-debug'
import { Route as AdminAdminAppointmentsIndexRouteImport } from './routes/_admin.admin.appointments.index'
import { Route as AdminAdminAppointmentsAppointmentIdRouteImport } from './routes/_admin.admin.appointments.$appointmentId'
import { Route as AdminAdminCmsIndexRouteImport } from './routes/_admin.admin.cms.index'
import { Route as AdminAdminCmsBannersRouteImport } from './routes/_admin.admin.cms.banners'
import { Route as AdminAdminCmsFaqRouteImport } from './routes/_admin.admin.cms.faq'
import { Route as AdminAdminCmsFooterRouteImport } from './routes/_admin.admin.cms.footer'
import { Route as AdminAdminCmsLegalRouteImport } from './routes/_admin.admin.cms.legal'
import { Route as AdminAdminCmsNavigationRouteImport } from './routes/_admin.admin.cms.navigation'
import { Route as AdminAdminCmsSeoRouteImport } from './routes/_admin.admin.cms.seo'
import { Route as AdminAdminCmsSettingsRouteImport } from './routes/_admin.admin.cms.settings'
import { Route as AdminAdminCmsWhatsappRouteImport } from './routes/_admin.admin.cms.whatsapp'
import { Route as CustomerAccountAppointmentsIndexRouteImport } from './routes/_customer.account.appointments.index'
import { Route as CustomerAccountAppointmentsAppointmentIdRouteImport } from './routes/_customer.account.appointments.$appointmentId'
import { Route as CustomerAccountOrdersIndexRouteImport } from './routes/_customer.account.orders.index'
import { Route as CustomerAccountOrdersOrderIdRouteImport } from './routes/_customer.account.orders.$orderId'
import { Route as CustomerAccountSubscriptionsIndexRouteImport } from './routes/_customer.account.subscriptions.index'
import { Route as CustomerAccountSubscriptionsSubscriptionIdRouteImport } from './routes/_customer.account.subscriptions.$subscriptionId'
import { Route as AdminAdminMarketingCampaignsIndexRouteImport } from './routes/_admin.admin.marketing.campaigns.index'
import { Route as AdminAdminMarketingCampaignsNewRouteImport } from './routes/_admin.admin.marketing.campaigns.new'
import { Route as CustomerAccountSubscriptionsSubscriptionIdCalendarRouteImport } from './routes/_customer.account.subscriptions.$subscriptionId.calendar'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const CustomerRoute = CustomerRouteImport.update({
            id: '/_customer',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AppointmentsRoute = AppointmentsRouteImport.update({
            id: '/appointments',path: '/appointments',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const MealPlansRoute = MealPlansRouteImport.update({
            id: '/meal-plans',path: '/meal-plans',getParentRoute: () => rootRouteImport
          })
const OrderRoute = OrderRouteImport.update({
            id: '/order',path: '/order',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProductsRoute = ProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => rootRouteImport
          })
const RefundCancellationRoute = RefundCancellationRouteImport.update({
            id: '/refund-cancellation',path: '/refund-cancellation',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReturnPolicyRoute = ReturnPolicyRouteImport.update({
            id: '/return-policy',path: '/return-policy',getParentRoute: () => rootRouteImport
          })
const ShippingDeliveryRoute = ShippingDeliveryRouteImport.update({
            id: '/shipping-delivery',path: '/shipping-delivery',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const TiffinRoute = TiffinRouteImport.update({
            id: '/tiffin',path: '/tiffin',getParentRoute: () => rootRouteImport
          })
const WeeklyMenuRoute = WeeklyMenuRouteImport.update({
            id: '/weekly-menu',path: '/weekly-menu',getParentRoute: () => rootRouteImport
          })
const AccountForgotPasswordRoute = AccountForgotPasswordRouteImport.update({
            id: '/account/forgot-password',path: '/account/forgot-password',getParentRoute: () => rootRouteImport
          })
const AccountSignInRoute = AccountSignInRouteImport.update({
            id: '/account/sign-in',path: '/account/sign-in',getParentRoute: () => rootRouteImport
          })
const AccountSignUpRoute = AccountSignUpRouteImport.update({
            id: '/account/sign-up',path: '/account/sign-up',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CareersIndexRoute = CareersIndexRouteImport.update({
            id: '/careers/',path: '/careers/',getParentRoute: () => rootRouteImport
          })
const CareersSlugRoute = CareersSlugRouteImport.update({
            id: '/careers/$slug',path: '/careers/$slug',getParentRoute: () => rootRouteImport
          })
const HealthProductsIndexRoute = HealthProductsIndexRouteImport.update({
            id: '/health-products/',path: '/health-products/',getParentRoute: () => rootRouteImport
          })
const HealthProductsSlugRoute = HealthProductsSlugRouteImport.update({
            id: '/health-products/$slug',path: '/health-products/$slug',getParentRoute: () => rootRouteImport
          })
const HealthProductsCartRoute = HealthProductsCartRouteImport.update({
            id: '/health-products/cart',path: '/health-products/cart',getParentRoute: () => rootRouteImport
          })
const MealPlansSlugRoute = MealPlansSlugRouteImport.update({
            id: '/meal-plans_/$slug',path: '/meal-plans/$slug',getParentRoute: () => rootRouteImport
          })
const MealPlansConfigureRoute = MealPlansConfigureRouteImport.update({
            id: '/meal-plans_/configure',path: '/meal-plans/configure',getParentRoute: () => rootRouteImport
          })
const OrderIndexRoute = OrderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrderRoute
          })
const OrderPayRoute = OrderPayRouteImport.update({
            id: '/pay',path: '/pay',getParentRoute: () => OrderRoute
          })
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AdminRoute
          })
const AdminAdminAboutRoute = AdminAdminAboutRouteImport.update({
            id: '/admin/about',path: '/admin/about',getParentRoute: () => AdminRoute
          })
const AdminAdminAddonsRoute = AdminAdminAddonsRouteImport.update({
            id: '/admin/addons',path: '/admin/addons',getParentRoute: () => AdminRoute
          })
const AdminAdminAvailabilityRoute = AdminAdminAvailabilityRouteImport.update({
            id: '/admin/availability',path: '/admin/availability',getParentRoute: () => AdminRoute
          })
const AdminAdminBackupRestoreRoute = AdminAdminBackupRestoreRouteImport.update({
            id: '/admin/backup-restore',path: '/admin/backup-restore',getParentRoute: () => AdminRoute
          })
const AdminAdminBeveragesRoute = AdminAdminBeveragesRouteImport.update({
            id: '/admin/beverages',path: '/admin/beverages',getParentRoute: () => AdminRoute
          })
const AdminAdminBulkRoute = AdminAdminBulkRouteImport.update({
            id: '/admin/bulk',path: '/admin/bulk',getParentRoute: () => AdminRoute
          })
const AdminAdminCareersRoute = AdminAdminCareersRouteImport.update({
            id: '/admin/careers',path: '/admin/careers',getParentRoute: () => AdminRoute
          })
const AdminAdminConsultationSettingsRoute = AdminAdminConsultationSettingsRouteImport.update({
            id: '/admin/consultation-settings',path: '/admin/consultation-settings',getParentRoute: () => AdminRoute
          })
const AdminAdminContactRoute = AdminAdminContactRouteImport.update({
            id: '/admin/contact',path: '/admin/contact',getParentRoute: () => AdminRoute
          })
const AdminAdminCouponsRoute = AdminAdminCouponsRouteImport.update({
            id: '/admin/coupons',path: '/admin/coupons',getParentRoute: () => AdminRoute
          })
const AdminAdminCustomerAnalyticsRoute = AdminAdminCustomerAnalyticsRouteImport.update({
            id: '/admin/customer-analytics',path: '/admin/customer-analytics',getParentRoute: () => AdminRoute
          })
const AdminAdminCustomersRoute = AdminAdminCustomersRouteImport.update({
            id: '/admin/customers',path: '/admin/customers',getParentRoute: () => AdminRoute
          })
const AdminAdminDeliveriesRoute = AdminAdminDeliveriesRouteImport.update({
            id: '/admin/deliveries',path: '/admin/deliveries',getParentRoute: () => AdminRoute
          })
const AdminAdminDeliveryAreasRoute = AdminAdminDeliveryAreasRouteImport.update({
            id: '/admin/delivery-areas',path: '/admin/delivery-areas',getParentRoute: () => AdminRoute
          })
const AdminAdminDeliveryPartnersRoute = AdminAdminDeliveryPartnersRouteImport.update({
            id: '/admin/delivery-partners',path: '/admin/delivery-partners',getParentRoute: () => AdminRoute
          })
const AdminAdminDeliveryRequestsRoute = AdminAdminDeliveryRequestsRouteImport.update({
            id: '/admin/delivery-requests',path: '/admin/delivery-requests',getParentRoute: () => AdminRoute
          })
const AdminAdminDeliveryTrackingRoute = AdminAdminDeliveryTrackingRouteImport.update({
            id: '/admin/delivery-tracking',path: '/admin/delivery-tracking',getParentRoute: () => AdminRoute
          })
const AdminAdminDeliveryZonesRoute = AdminAdminDeliveryZonesRouteImport.update({
            id: '/admin/delivery-zones',path: '/admin/delivery-zones',getParentRoute: () => AdminRoute
          })
const AdminAdminDemoDataRoute = AdminAdminDemoDataRouteImport.update({
            id: '/admin/demo-data',path: '/admin/demo-data',getParentRoute: () => AdminRoute
          })
const AdminAdminDispatchRoute = AdminAdminDispatchRouteImport.update({
            id: '/admin/dispatch',path: '/admin/dispatch',getParentRoute: () => AdminRoute
          })
const AdminAdminDispatchBoardRoute = AdminAdminDispatchBoardRouteImport.update({
            id: '/admin/dispatch-board',path: '/admin/dispatch-board',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailLogsRoute = AdminAdminEmailLogsRouteImport.update({
            id: '/admin/email-logs',path: '/admin/email-logs',getParentRoute: () => AdminRoute
          })
const AdminAdminEnquiriesRoute = AdminAdminEnquiriesRouteImport.update({
            id: '/admin/enquiries',path: '/admin/enquiries',getParentRoute: () => AdminRoute
          })
const AdminAdminFoodAnalyticsRoute = AdminAdminFoodAnalyticsRouteImport.update({
            id: '/admin/food-analytics',path: '/admin/food-analytics',getParentRoute: () => AdminRoute
          })
const AdminAdminGoodsReceiptRoute = AdminAdminGoodsReceiptRouteImport.update({
            id: '/admin/goods-receipt',path: '/admin/goods-receipt',getParentRoute: () => AdminRoute
          })
const AdminAdminHomepageRoute = AdminAdminHomepageRouteImport.update({
            id: '/admin/homepage',path: '/admin/homepage',getParentRoute: () => AdminRoute
          })
const AdminAdminImplementationWizardRoute = AdminAdminImplementationWizardRouteImport.update({
            id: '/admin/implementation-wizard',path: '/admin/implementation-wizard',getParentRoute: () => AdminRoute
          })
const AdminAdminImportHistoryRoute = AdminAdminImportHistoryRouteImport.update({
            id: '/admin/import-history',path: '/admin/import-history',getParentRoute: () => AdminRoute
          })
const AdminAdminInventoryCategoriesRoute = AdminAdminInventoryCategoriesRouteImport.update({
            id: '/admin/inventory-categories',path: '/admin/inventory-categories',getParentRoute: () => AdminRoute
          })
const AdminAdminInventoryDashboardRoute = AdminAdminInventoryDashboardRouteImport.update({
            id: '/admin/inventory-dashboard',path: '/admin/inventory-dashboard',getParentRoute: () => AdminRoute
          })
const AdminAdminInventoryReportsRoute = AdminAdminInventoryReportsRouteImport.update({
            id: '/admin/inventory-reports',path: '/admin/inventory-reports',getParentRoute: () => AdminRoute
          })
const AdminAdminInventorySuppliersRoute = AdminAdminInventorySuppliersRouteImport.update({
            id: '/admin/inventory-suppliers',path: '/admin/inventory-suppliers',getParentRoute: () => AdminRoute
          })
const AdminAdminJournalRoute = AdminAdminJournalRouteImport.update({
            id: '/admin/journal',path: '/admin/journal',getParentRoute: () => AdminRoute
          })
const AdminAdminKitchenRoute = AdminAdminKitchenRouteImport.update({
            id: '/admin/kitchen',path: '/admin/kitchen',getParentRoute: () => AdminRoute
          })
const AdminAdminKitchenProductionRoute = AdminAdminKitchenProductionRouteImport.update({
            id: '/admin/kitchen-production',path: '/admin/kitchen-production',getParentRoute: () => AdminRoute
          })
const AdminAdminLeadsRoute = AdminAdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => AdminRoute
          })
const AdminAdminManualOrdersRoute = AdminAdminManualOrdersRouteImport.update({
            id: '/admin/manual-orders',path: '/admin/manual-orders',getParentRoute: () => AdminRoute
          })
const AdminAdminMealPlansRoute = AdminAdminMealPlansRouteImport.update({
            id: '/admin/meal-plans',path: '/admin/meal-plans',getParentRoute: () => AdminRoute
          })
const AdminAdminMealPlansV2Route = AdminAdminMealPlansV2RouteImport.update({
            id: '/admin/meal-plans-v2',path: '/admin/meal-plans-v2',getParentRoute: () => AdminRoute
          })
const AdminAdminMealPlansV2PreviewRoute = AdminAdminMealPlansV2PreviewRouteImport.update({
            id: '/admin/meal-plans-v2-preview',path: '/admin/meal-plans-v2-preview',getParentRoute: () => AdminRoute
          })
const AdminAdminMediaRoute = AdminAdminMediaRouteImport.update({
            id: '/admin/media',path: '/admin/media',getParentRoute: () => AdminRoute
          })
const AdminAdminNewsletterRoute = AdminAdminNewsletterRouteImport.update({
            id: '/admin/newsletter',path: '/admin/newsletter',getParentRoute: () => AdminRoute
          })
const AdminAdminOperationsRoute = AdminAdminOperationsRouteImport.update({
            id: '/admin/operations',path: '/admin/operations',getParentRoute: () => AdminRoute
          })
const AdminAdminOrdersRoute = AdminAdminOrdersRouteImport.update({
            id: '/admin/orders',path: '/admin/orders',getParentRoute: () => AdminRoute
          })
const AdminAdminProductOrdersRoute = AdminAdminProductOrdersRouteImport.update({
            id: '/admin/product-orders',path: '/admin/product-orders',getParentRoute: () => AdminRoute
          })
const AdminAdminProductionCleanupRoute = AdminAdminProductionCleanupRouteImport.update({
            id: '/admin/production-cleanup',path: '/admin/production-cleanup',getParentRoute: () => AdminRoute
          })
const AdminAdminProductsRoute = AdminAdminProductsRouteImport.update({
            id: '/admin/products',path: '/admin/products',getParentRoute: () => AdminRoute
          })
const AdminAdminPurchaseOrdersRoute = AdminAdminPurchaseOrdersRouteImport.update({
            id: '/admin/purchase-orders',path: '/admin/purchase-orders',getParentRoute: () => AdminRoute
          })
const AdminAdminReportsRoute = AdminAdminReportsRouteImport.update({
            id: '/admin/reports',path: '/admin/reports',getParentRoute: () => AdminRoute
          })
const AdminAdminReturnsRoute = AdminAdminReturnsRouteImport.update({
            id: '/admin/returns',path: '/admin/returns',getParentRoute: () => AdminRoute
          })
const AdminAdminSaladsRoute = AdminAdminSaladsRouteImport.update({
            id: '/admin/salads',path: '/admin/salads',getParentRoute: () => AdminRoute
          })
const AdminAdminSalesAnalyticsRoute = AdminAdminSalesAnalyticsRouteImport.update({
            id: '/admin/sales-analytics',path: '/admin/sales-analytics',getParentRoute: () => AdminRoute
          })
const AdminAdminSettingsRoute = AdminAdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => AdminRoute
          })
const AdminAdminSettingsAiChatRoute = AdminAdminSettingsAiChatRouteImport.update({
            id: '/admin/settings-ai-chat',path: '/admin/settings-ai-chat',getParentRoute: () => AdminRoute
          })
const AdminAdminShiftPlanningRoute = AdminAdminShiftPlanningRouteImport.update({
            id: '/admin/shift-planning',path: '/admin/shift-planning',getParentRoute: () => AdminRoute
          })
const AdminAdminSoupsRoute = AdminAdminSoupsRouteImport.update({
            id: '/admin/soups',path: '/admin/soups',getParentRoute: () => AdminRoute
          })
const AdminAdminStockAdjustmentsRoute = AdminAdminStockAdjustmentsRouteImport.update({
            id: '/admin/stock-adjustments',path: '/admin/stock-adjustments',getParentRoute: () => AdminRoute
          })
const AdminAdminStockItemsRoute = AdminAdminStockItemsRouteImport.update({
            id: '/admin/stock-items',path: '/admin/stock-items',getParentRoute: () => AdminRoute
          })
const AdminAdminStockMovementRoute = AdminAdminStockMovementRouteImport.update({
            id: '/admin/stock-movement',path: '/admin/stock-movement',getParentRoute: () => AdminRoute
          })
const AdminAdminSubscriptionExtensionsRoute = AdminAdminSubscriptionExtensionsRouteImport.update({
            id: '/admin/subscription-extensions',path: '/admin/subscription-extensions',getParentRoute: () => AdminRoute
          })
const AdminAdminSystemConfigurationRoute = AdminAdminSystemConfigurationRouteImport.update({
            id: '/admin/system-configuration',path: '/admin/system-configuration',getParentRoute: () => AdminRoute
          })
const AdminAdminSystemHealthRoute = AdminAdminSystemHealthRouteImport.update({
            id: '/admin/system-health',path: '/admin/system-health',getParentRoute: () => AdminRoute
          })
const AdminAdminTenantsRoute = AdminAdminTenantsRouteImport.update({
            id: '/admin/tenants',path: '/admin/tenants',getParentRoute: () => AdminRoute
          })
const AdminAdminTestimonialsRoute = AdminAdminTestimonialsRouteImport.update({
            id: '/admin/testimonials',path: '/admin/testimonials',getParentRoute: () => AdminRoute
          })
const AdminAdminTiffinRoute = AdminAdminTiffinRouteImport.update({
            id: '/admin/tiffin',path: '/admin/tiffin',getParentRoute: () => AdminRoute
          })
const AdminAdminUsersRoute = AdminAdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => AdminRoute
          })
const AdminAdminVehiclesRoute = AdminAdminVehiclesRouteImport.update({
            id: '/admin/vehicles',path: '/admin/vehicles',getParentRoute: () => AdminRoute
          })
const AdminAdminVideoSpecialsRoute = AdminAdminVideoSpecialsRouteImport.update({
            id: '/admin/video-specials',path: '/admin/video-specials',getParentRoute: () => AdminRoute
          })
const AdminAdminWalletRoute = AdminAdminWalletRouteImport.update({
            id: '/admin/wallet',path: '/admin/wallet',getParentRoute: () => AdminRoute
          })
const AdminAdminWebsiteAnalyticsRoute = AdminAdminWebsiteAnalyticsRouteImport.update({
            id: '/admin/website-analytics',path: '/admin/website-analytics',getParentRoute: () => AdminRoute
          })
const AdminAdminWeeklyMenuRoute = AdminAdminWeeklyMenuRouteImport.update({
            id: '/admin/weekly-menu',path: '/admin/weekly-menu',getParentRoute: () => AdminRoute
          })
const AdminAdminWhatsappTemplatesRoute = AdminAdminWhatsappTemplatesRouteImport.update({
            id: '/admin/whatsapp-templates',path: '/admin/whatsapp-templates',getParentRoute: () => AdminRoute
          })
const CustomerAccountIndexRoute = CustomerAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => CustomerRoute
          })
const CustomerAccountAddressesRoute = CustomerAccountAddressesRouteImport.update({
            id: '/account/addresses',path: '/account/addresses',getParentRoute: () => CustomerRoute
          })
const CustomerAccountProfileRoute = CustomerAccountProfileRouteImport.update({
            id: '/account/profile',path: '/account/profile',getParentRoute: () => CustomerRoute
          })
const CustomerAccountTiffinRoute = CustomerAccountTiffinRouteImport.update({
            id: '/account/tiffin',path: '/account/tiffin',getParentRoute: () => CustomerRoute
          })
const CustomerAccountWalletRoute = CustomerAccountWalletRouteImport.update({
            id: '/account/wallet',path: '/account/wallet',getParentRoute: () => CustomerRoute
          })
const ApiPublicVapiInitDebugRoute = ApiPublicVapiInitDebugRouteImport.update({
            id: '/api/public/vapi-init-debug',path: '/api/public/vapi-init-debug',getParentRoute: () => rootRouteImport
          })
const AdminAdminAppointmentsIndexRoute = AdminAdminAppointmentsIndexRouteImport.update({
            id: '/admin/appointments/',path: '/admin/appointments/',getParentRoute: () => AdminRoute
          })
const AdminAdminAppointmentsAppointmentIdRoute = AdminAdminAppointmentsAppointmentIdRouteImport.update({
            id: '/admin/appointments/$appointmentId',path: '/admin/appointments/$appointmentId',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsIndexRoute = AdminAdminCmsIndexRouteImport.update({
            id: '/admin/cms/',path: '/admin/cms/',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsBannersRoute = AdminAdminCmsBannersRouteImport.update({
            id: '/admin/cms/banners',path: '/admin/cms/banners',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsFaqRoute = AdminAdminCmsFaqRouteImport.update({
            id: '/admin/cms/faq',path: '/admin/cms/faq',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsFooterRoute = AdminAdminCmsFooterRouteImport.update({
            id: '/admin/cms/footer',path: '/admin/cms/footer',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsLegalRoute = AdminAdminCmsLegalRouteImport.update({
            id: '/admin/cms/legal',path: '/admin/cms/legal',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsNavigationRoute = AdminAdminCmsNavigationRouteImport.update({
            id: '/admin/cms/navigation',path: '/admin/cms/navigation',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsSeoRoute = AdminAdminCmsSeoRouteImport.update({
            id: '/admin/cms/seo',path: '/admin/cms/seo',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsSettingsRoute = AdminAdminCmsSettingsRouteImport.update({
            id: '/admin/cms/settings',path: '/admin/cms/settings',getParentRoute: () => AdminRoute
          })
const AdminAdminCmsWhatsappRoute = AdminAdminCmsWhatsappRouteImport.update({
            id: '/admin/cms/whatsapp',path: '/admin/cms/whatsapp',getParentRoute: () => AdminRoute
          })
const CustomerAccountAppointmentsIndexRoute = CustomerAccountAppointmentsIndexRouteImport.update({
            id: '/account/appointments/',path: '/account/appointments/',getParentRoute: () => CustomerRoute
          })
const CustomerAccountAppointmentsAppointmentIdRoute = CustomerAccountAppointmentsAppointmentIdRouteImport.update({
            id: '/account/appointments/$appointmentId',path: '/account/appointments/$appointmentId',getParentRoute: () => CustomerRoute
          })
const CustomerAccountOrdersIndexRoute = CustomerAccountOrdersIndexRouteImport.update({
            id: '/account/orders/',path: '/account/orders/',getParentRoute: () => CustomerRoute
          })
const CustomerAccountOrdersOrderIdRoute = CustomerAccountOrdersOrderIdRouteImport.update({
            id: '/account/orders/$orderId',path: '/account/orders/$orderId',getParentRoute: () => CustomerRoute
          })
const CustomerAccountSubscriptionsIndexRoute = CustomerAccountSubscriptionsIndexRouteImport.update({
            id: '/account/subscriptions/',path: '/account/subscriptions/',getParentRoute: () => CustomerRoute
          })
const CustomerAccountSubscriptionsSubscriptionIdRoute = CustomerAccountSubscriptionsSubscriptionIdRouteImport.update({
            id: '/account/subscriptions/$subscriptionId',path: '/account/subscriptions/$subscriptionId',getParentRoute: () => CustomerRoute
          })
const AdminAdminMarketingCampaignsIndexRoute = AdminAdminMarketingCampaignsIndexRouteImport.update({
            id: '/admin/marketing/campaigns/',path: '/admin/marketing/campaigns/',getParentRoute: () => AdminRoute
          })
const AdminAdminMarketingCampaignsNewRoute = AdminAdminMarketingCampaignsNewRouteImport.update({
            id: '/admin/marketing/campaigns/new',path: '/admin/marketing/campaigns/new',getParentRoute: () => AdminRoute
          })
const CustomerAccountSubscriptionsSubscriptionIdCalendarRoute = CustomerAccountSubscriptionsSubscriptionIdCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => CustomerAccountSubscriptionsSubscriptionIdRoute
          })





const AdminRouteChildren = {
  AdminAdminAboutRoute: AdminAdminAboutRoute,AdminAdminAddonsRoute: AdminAdminAddonsRoute,AdminAdminAvailabilityRoute: AdminAdminAvailabilityRoute,AdminAdminBackupRestoreRoute: AdminAdminBackupRestoreRoute,AdminAdminBeveragesRoute: AdminAdminBeveragesRoute,AdminAdminBulkRoute: AdminAdminBulkRoute,AdminAdminCareersRoute: AdminAdminCareersRoute,AdminAdminConsultationSettingsRoute: AdminAdminConsultationSettingsRoute,AdminAdminContactRoute: AdminAdminContactRoute,AdminAdminCouponsRoute: AdminAdminCouponsRoute,AdminAdminCustomerAnalyticsRoute: AdminAdminCustomerAnalyticsRoute,AdminAdminCustomersRoute: AdminAdminCustomersRoute,AdminAdminDeliveriesRoute: AdminAdminDeliveriesRoute,AdminAdminDeliveryAreasRoute: AdminAdminDeliveryAreasRoute,AdminAdminDeliveryPartnersRoute: AdminAdminDeliveryPartnersRoute,AdminAdminDeliveryRequestsRoute: AdminAdminDeliveryRequestsRoute,AdminAdminDeliveryTrackingRoute: AdminAdminDeliveryTrackingRoute,AdminAdminDeliveryZonesRoute: AdminAdminDeliveryZonesRoute,AdminAdminDemoDataRoute: AdminAdminDemoDataRoute,AdminAdminDispatchRoute: AdminAdminDispatchRoute,AdminAdminDispatchBoardRoute: AdminAdminDispatchBoardRoute,AdminAdminEmailLogsRoute: AdminAdminEmailLogsRoute,AdminAdminEnquiriesRoute: AdminAdminEnquiriesRoute,AdminAdminFoodAnalyticsRoute: AdminAdminFoodAnalyticsRoute,AdminAdminGoodsReceiptRoute: AdminAdminGoodsReceiptRoute,AdminAdminHomepageRoute: AdminAdminHomepageRoute,AdminAdminImplementationWizardRoute: AdminAdminImplementationWizardRoute,AdminAdminImportHistoryRoute: AdminAdminImportHistoryRoute,AdminAdminInventoryCategoriesRoute: AdminAdminInventoryCategoriesRoute,AdminAdminInventoryDashboardRoute: AdminAdminInventoryDashboardRoute,AdminAdminInventoryReportsRoute: AdminAdminInventoryReportsRoute,AdminAdminInventorySuppliersRoute: AdminAdminInventorySuppliersRoute,AdminAdminJournalRoute: AdminAdminJournalRoute,AdminAdminKitchenRoute: AdminAdminKitchenRoute,AdminAdminKitchenProductionRoute: AdminAdminKitchenProductionRoute,AdminAdminLeadsRoute: AdminAdminLeadsRoute,AdminAdminManualOrdersRoute: AdminAdminManualOrdersRoute,AdminAdminMealPlansRoute: AdminAdminMealPlansRoute,AdminAdminMealPlansV2Route: AdminAdminMealPlansV2Route,AdminAdminMealPlansV2PreviewRoute: AdminAdminMealPlansV2PreviewRoute,AdminAdminMediaRoute: AdminAdminMediaRoute,AdminAdminNewsletterRoute: AdminAdminNewsletterRoute,AdminAdminOperationsRoute: AdminAdminOperationsRoute,AdminAdminOrdersRoute: AdminAdminOrdersRoute,AdminAdminProductOrdersRoute: AdminAdminProductOrdersRoute,AdminAdminProductionCleanupRoute: AdminAdminProductionCleanupRoute,AdminAdminProductsRoute: AdminAdminProductsRoute,AdminAdminPurchaseOrdersRoute: AdminAdminPurchaseOrdersRoute,AdminAdminReportsRoute: AdminAdminReportsRoute,AdminAdminReturnsRoute: AdminAdminReturnsRoute,AdminAdminSaladsRoute: AdminAdminSaladsRoute,AdminAdminSalesAnalyticsRoute: AdminAdminSalesAnalyticsRoute,AdminAdminSettingsRoute: AdminAdminSettingsRoute,AdminAdminSettingsAiChatRoute: AdminAdminSettingsAiChatRoute,AdminAdminShiftPlanningRoute: AdminAdminShiftPlanningRoute,AdminAdminSoupsRoute: AdminAdminSoupsRoute,AdminAdminStockAdjustmentsRoute: AdminAdminStockAdjustmentsRoute,AdminAdminStockItemsRoute: AdminAdminStockItemsRoute,AdminAdminStockMovementRoute: AdminAdminStockMovementRoute,AdminAdminSubscriptionExtensionsRoute: AdminAdminSubscriptionExtensionsRoute,AdminAdminSystemConfigurationRoute: AdminAdminSystemConfigurationRoute,AdminAdminSystemHealthRoute: AdminAdminSystemHealthRoute,AdminAdminTenantsRoute: AdminAdminTenantsRoute,AdminAdminTestimonialsRoute: AdminAdminTestimonialsRoute,AdminAdminTiffinRoute: AdminAdminTiffinRoute,AdminAdminUsersRoute: AdminAdminUsersRoute,AdminAdminVehiclesRoute: AdminAdminVehiclesRoute,AdminAdminVideoSpecialsRoute: AdminAdminVideoSpecialsRoute,AdminAdminWalletRoute: AdminAdminWalletRoute,AdminAdminWebsiteAnalyticsRoute: AdminAdminWebsiteAnalyticsRoute,AdminAdminWeeklyMenuRoute: AdminAdminWeeklyMenuRoute,AdminAdminWhatsappTemplatesRoute: AdminAdminWhatsappTemplatesRoute,AdminAdminIndexRoute: AdminAdminIndexRoute,AdminAdminAppointmentsAppointmentIdRoute: AdminAdminAppointmentsAppointmentIdRoute,AdminAdminCmsBannersRoute: AdminAdminCmsBannersRoute,AdminAdminCmsFaqRoute: AdminAdminCmsFaqRoute,AdminAdminCmsFooterRoute: AdminAdminCmsFooterRoute,AdminAdminCmsLegalRoute: AdminAdminCmsLegalRoute,AdminAdminCmsNavigationRoute: AdminAdminCmsNavigationRoute,AdminAdminCmsSeoRoute: AdminAdminCmsSeoRoute,AdminAdminCmsSettingsRoute: AdminAdminCmsSettingsRoute,AdminAdminCmsWhatsappRoute: AdminAdminCmsWhatsappRoute,AdminAdminAppointmentsIndexRoute: AdminAdminAppointmentsIndexRoute,AdminAdminCmsIndexRoute: AdminAdminCmsIndexRoute,AdminAdminMarketingCampaignsNewRoute: AdminAdminMarketingCampaignsNewRoute,AdminAdminMarketingCampaignsIndexRoute: AdminAdminMarketingCampaignsIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const CustomerAccountSubscriptionsSubscriptionIdRouteChildren = {
  CustomerAccountSubscriptionsSubscriptionIdCalendarRoute: CustomerAccountSubscriptionsSubscriptionIdCalendarRoute
}

const CustomerAccountSubscriptionsSubscriptionIdRouteWithChildren = CustomerAccountSubscriptionsSubscriptionIdRoute._addFileChildren(CustomerAccountSubscriptionsSubscriptionIdRouteChildren)



const CustomerRouteChildren = {
  CustomerAccountAddressesRoute: CustomerAccountAddressesRoute,CustomerAccountProfileRoute: CustomerAccountProfileRoute,CustomerAccountTiffinRoute: CustomerAccountTiffinRoute,CustomerAccountWalletRoute: CustomerAccountWalletRoute,CustomerAccountIndexRoute: CustomerAccountIndexRoute,CustomerAccountAppointmentsAppointmentIdRoute: CustomerAccountAppointmentsAppointmentIdRoute,CustomerAccountOrdersOrderIdRoute: CustomerAccountOrdersOrderIdRoute,CustomerAccountSubscriptionsSubscriptionIdRoute: CustomerAccountSubscriptionsSubscriptionIdRouteWithChildren,CustomerAccountAppointmentsIndexRoute: CustomerAccountAppointmentsIndexRoute,CustomerAccountOrdersIndexRoute: CustomerAccountOrdersIndexRoute,CustomerAccountSubscriptionsIndexRoute: CustomerAccountSubscriptionsIndexRoute
}

const CustomerRouteWithChildren = CustomerRoute._addFileChildren(CustomerRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const OrderRouteChildren = {
  OrderPayRoute: OrderPayRoute,OrderIndexRoute: OrderIndexRoute
}

const OrderRouteWithChildren = OrderRoute._addFileChildren(OrderRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,CustomerRoute: CustomerRouteWithChildren,AboutRoute: AboutRoute,AppointmentsRoute: AppointmentsRoute,BlogRoute: BlogRouteWithChildren,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,FaqRoute: FaqRoute,MealPlansRoute: MealPlansRoute,OrderRoute: OrderRouteWithChildren,PrivacyPolicyRoute: PrivacyPolicyRoute,ProductsRoute: ProductsRoute,RefundCancellationRoute: RefundCancellationRoute,ResetPasswordRoute: ResetPasswordRoute,ReturnPolicyRoute: ReturnPolicyRoute,ShippingDeliveryRoute: ShippingDeliveryRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,TiffinRoute: TiffinRoute,WeeklyMenuRoute: WeeklyMenuRoute,AccountForgotPasswordRoute: AccountForgotPasswordRoute,AccountSignInRoute: AccountSignInRoute,AccountSignUpRoute: AccountSignUpRoute,AdminLoginRoute: AdminLoginRoute,CareersSlugRoute: CareersSlugRoute,HealthProductsSlugRoute: HealthProductsSlugRoute,HealthProductsCartRoute: HealthProductsCartRoute,MealPlansSlugRoute: MealPlansSlugRoute,MealPlansConfigureRoute: MealPlansConfigureRoute,CareersIndexRoute: CareersIndexRoute,HealthProductsIndexRoute: HealthProductsIndexRoute,ApiPublicVapiInitDebugRoute: ApiPublicVapiInitDebugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)